export const features = {
    "template": "template2",
    "companyName": "The Philadelphia Contributionship (MODEL)",
    "inowEndpoint": "https://model-tpc.in.guidewire.net",
    "tokenIssuer": "https://tpc-inow.oktapreview.com/oauth2/default",
    "clientId": "0oae3zmv5ydU0a5Lm1d7",
    "features": {
        "CustomContentPage1": false,
        "CustomContentPage2": false,
        "addRegistrationEmail": false,
        "agentEmail": true,
        "agentLink": true,
        "agentPanel": true,
        "blockAchNumberOps": false,
        "changeCoverage": false,
        "claimDetailsDocuments": true,
        "claimDetailsPayments": true,
        "claimDocumentUpload": true,
        "claimList": true,
        "claimStatus": true,
        "combinePolicies": false,
        "coverageDetails": true,
        "cpPortalLinking": false,
        "customPrivacyStatement": false,
        "customTOS": false,
        "deactivateUserOnly": true,
        "defaultLossDateTime": true,
        "desktopDeliveryPreferencesDefaultExpanded": true,
        "editPayPlan": true,
        "hasOpenBalance": true,
        "loginPanelExpirationDate": "2999-01-01",
        "mfaEnabled": "true",
        "mobileDeliveryPreferencesDefaultExpanded": false,
        "needHelp": true,
        "notificationPreferences": false,
        "otherPaymentAmountAllowed": true,
        "paperlessChoiceUpdate": true,
        "passwordResetInfo": false,
        "payPlanTypesToFilter": [
            "Mortgagee",
            "Agent",
            "Statement"
        ],
        "pendingOrScheduledPaymentsList": true,
        "policyDetailsAddress": true,
        "policyDetailsAddressTypeCd": [],
        "policyDocumentUpload": true,
        "policyForms": false,
        "policyFormsDownload": false,
        "policyUserAttachmentsDisplay": true,
        "printButtonEnabled": false,
        "recentPaymentsList": true,
        "rememberMe": true,
        "reportClaim": true,
        "scheduledPayments": false,
        "showImageTag": true,
        "showInstallPWA": false,
        "standardPhoneLength": false,
        "unauthenticatedPayments": true,
        "unauthenticatedReportClaim": true,
        "underlyingPoliciesPayPlansEditable": false,
        "useGooglePlacesInReportClaimFlow": true,
        "useInsuredAttachments": false,
        "verifyAddress": true,
        "viewChangeRequests": false,
        "faviconFileExtension": "ico",
        "maxUploadFileSize": "500mb",
        "processingFee": 4.95
    },
    "keys": {
        "googleAnalytics": "UA-58509639-4",
        "googleAnalytics4": "G-PQ8RB3X14M",
        "googleAnalytics4GwDev": "G-R8Y22B4GYL",
        "googleAnalytics4GwProd": "G-C0D8F7WEDX",
        "googlePlacesApi": "AIzaSyAziEKy-BLqcRWPzo5ycqyhbDDknmvQZ94",
        "googleAnalyticsGwDev": "UA-81735613-3"
    },
    "salesPortalUrl": "https://tpc-model-cp.nu-1-us-west-2.guidewire.net",
    "cpProducts": [
        "Homeowners",
        "Personal Auto"
    ],
    "paymentApiUrl": "https://midas.api.omega2-andromeda.guidewire.net",
    "paymentTenantName": "tenant.tpc",
    "paymentConfigIds": {
        "TPC": "5167002",
        "GIC": "5167002",
        "PCIC": "5167002"
    },
    "paymentMethods": [
        "ACH",
        "CC"
    ],
    "anonymousPaymentMethods": [
        "ACH",
        "CC"
    ],
    "achEntryClassCode": "PPD",
    "processingFee": 4.95,
    "maxUploadFileSize": "500mb",
    "attachmentTemplatesLimit": "20",
    "policiesCountLimit": "50",
    "billingAccountsCountLimit": "50",
    "faviconFileExtension": "ico",
    "policyCreatedSinceDt": 365,
    "policyStatusCd": "Active,Non-Renewed,Non-Renew Requested,Cancel Notice",
    "passwordConstraints": [
        {
            "constraint": "minLength",
            "value": 16,
            "message": "Use at least 16 characters"
        },
        {
            "constraint": "minNumber",
            "value": 1,
            "message": "Contain at least one number"
        },
        {
            "constraint": "minUpperCase",
            "value": 1,
            "message": "Contain at least one upper case letter"
        },
        {
            "constraint": "minLowerCase",
            "value": 1,
            "message": "Contain at least one lower case letter"
        }
    ],
    "userIdConstraints": [
        {
            "constraint": "minLength",
            "value": 3,
            "message": "Use at least 3 characters"
        }
    ],
    "downTime": {
        "beginTime": "2020-01-01T17:00-05:00",
        "endTime": "2020-12-31T17:00-05:00",
        "title": "<p>System Down for Maintenance</p>",
        "body": "<p>ATTN: MY KEY WILL BE TEMPORARILY UNAVAILABLE beginning on Friday, February 2, 2024 at 01:00 PM EST and ending on Saturday, February 3, 2024 at 01:00 AM EST to allow for planned system maintenance.</p>"
    },
    "signIn": {
        "title": "<p> <h4>TPC Client Portal - MyKey</h4></p> <br/><br/>",
        "body": "<p>Welcome to the TPC Client Portal, MyKey, where you can access important information, pay your bill, and communicate with us about your insurance policy with The Philadelphia Contributionship.</p><br/><p><h4> System Update: Action Required</h4></p><p> We have recently updated our system. This system upgrade will provide you with more functionality and improved ease-of-use in the future.</p><br/><p>Note: This update requires registered users to re-register and create a new account for MyKey.</p><br/><p>If you have already registered for MyKey, click the &#34;Create an Account&#34; button to the right and follow the instructions to create your new account.</p><br/><p>If you have any questions or need help setting up your new MyKey account, please call our Customer Service Department at (888) 627-1752.</p>"
    },
    "notificationSmsNumber": "",
    "billingStatusCd": "Normal, Cancel, Legal",
    "apiResponseSizeLimit": 100,
    "_meta": {
        "build": "4.0.0-26-0f270d4",
        "commit": "0f270d45a3ea13fb9705aa7a645eb0b1d7e416b1",
        "company": "tpc",
        "date": "2025-07-01T19:29:33+00:00",
        "source": "serviceportal-four-config",
        "version": "4.0.0",
        "imageTag": ""
    },
    "paymentSdkUrl": "https://js-sdk-prod.payments.guidewire.net/v1/gw-payments-sdk.js"
};